import { exactagData, type ExactagData } from "../core/data";
import { exactagScope } from "../core/utils";

const log = exactagScope.scope("collect.vertical");

/**
 *
 */
export const verticalDataRetrievalCallbacks: Record<
  string,
  VerticalDataCallback
> = {};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export type VerticalDataCallback = (data: ExactagData) => ExactagData;

/**
 *
 *
 *
 *
 *
 */
export function registerVerticalDataCallback(
  triggerID: string,
  cb: VerticalDataCallback
): void {
  if (verticalDataRetrievalCallbacks[triggerID])
    log.warn(
      "Vertical data callback ID",
      `"${triggerID}"`,
      "already registered! It will be overwritten."
    );

  verticalDataRetrievalCallbacks[triggerID] = cb;
}

export function addVerticalDataFromElement(this: ExactagData, element: HTMLElement) {
  const data = this;

  /*                                                           */
  const { trigger: triggerID } = element.dataset;
  if (!triggerID) {
    log.warn("No trigger ID found in element", element);
    return;
  }

  /*                                  */
  const fn = verticalDataRetrievalCallbacks[triggerID];
  if (!fn || typeof fn !== "function") {
    log.warn("No function registered for trigger ID", triggerID);
    return;
  }

  const result = fn(data);
  if (!result || typeof result !== "object") {
    log.info("No data returned from function for trigger ID", triggerID);
    return;
  }

  if (result === data) {
    log.warn(
      "Callback function for trigger ID",
      triggerID,
      "returned the same object as input!"
    );
    return;
  }

  log.info("Adding data from function for trigger ID", triggerID, result);
  Object.assign(data, result);
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function addVerticalsData(data = exactagData): ExactagData {
  /*                                                 */
  document
    .querySelectorAll<HTMLElement>(".exactag")
    .forEach(addVerticalDataFromElement, data);
  return data;
}
